var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_9473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V8H0V0Z",
    fill: "#AF2633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8H32V16H0V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16H32V24H0V16Z",
    fill: "#2A4E8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_9473"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.00244141,
    width: 32,
    height: 24.0047,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNl);
export default __webpack_public_path__ + "static/media/nl.d97f401cc7f0e7afe841aae0bad504b5.svg";
export { ForwardRef as ReactComponent };